import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import InsertChartIcon from '@mui/icons-material/InsertChart';

import ItemWiseReportHsn from '../ARC_Reconciliation/Purchase/ItemWiseReport/ItemWiseReport';
import AgeingRecivableReport from './AgingReport/Ageing_Recivable_Report';
import AgeingPayableReport from './AgingReport/Ageing_payble_Report';
// import C2CReport from './C2C/c2CReport';
import ItcAvailReport from '../ARC_Reconciliation/Purchase/ITC_Avaial_Report/ItcReport';
import ItcReversalReport from '../ARC_Reconciliation/Purchase/ITC_Reversal_Report/itc_reversal';
import VendorCancellation from './VendoreCancellation/VendorCancellation';
import MultiMonth from './MultiMonth/MultiMonth';
import HsnSummaryReport from '../ARC_Reconciliation/Purchase/HSN Summary Report/HsnSummaryReport';
import Gtsr9InwardComparison from '../ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/inward';
import Gtsr9OutwardComparison from '../ARC_Reconciliation/Purchase/GSTR-9 Reconciliation/Outward';
import GSTComputationReport from '../ARC_Reconciliation/Purchase/GstComputationReport/Gst_computation_report';
import RCMReport from '../ARC_Reconciliation/Purchase/RCM_Report/rcmReport';
import TdsReport from './TDS_Applicability_Report/TdsReport';
import GstLedgers from './GSTLedger/GstLedger';
import LogTables from './Form16/logtable';
import SectionReport from './SectionWiseReport_gstr1_vs3b/sectionwiseReport';
import RcmReport from './rcmReport/rcmReport';


export default function ReportsCards() {
    const history = useHistory();
    const location = useLocation();

    const [sitemapData, setSitemapData] = useState(null);
    const [selectedReport, setSelectedReport] = useState(null);

    // Load sitemap from localStorage
    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    const wrokingCapitalAccess = sitemapData?.["REPORT ANALYTICS"]?.['WORKING CAPITAL'] || [];
    const statutoryComplianceAccess = sitemapData?.["REPORT ANALYTICS"]?.['STATUTORY COMPLIANCE'] || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const workingCapitalReportOptions = [
        wrokingCapitalAccess?.includes("ITEM WISE REPORT") && {
            label: 'Item wise report',
            icon: <BarChartIcon />,
            path: '/itemWiseReportHsn',
            component: ItemWiseReportHsn
        },
        wrokingCapitalAccess?.includes("AGEING REPORT") && {
            label: 'Ageing Receivable',
            icon: <PieChartIcon />,
            path: '/ageing_recivable_report_dashboard',
            component: AgeingRecivableReport
        },
        wrokingCapitalAccess?.includes("AGEING REPORT") && {
            label: 'Ageing Payable',
            icon: <BubbleChartIcon />,
            path: '/ageing_payable_report_dashboard',
            component: AgeingPayableReport
        },
        // wrokingCapitalAccess?.includes("C2C REPORT") && {
        //     label: 'C2C Analytics',
        //     icon: <InsertChartIcon />,
        //     path: '/C2CReportDashboard',
        //     component: C2CReport
        // },
    ].filter(Boolean);

    const statutoryComplianceReportOptions = [
        statutoryComplianceAccess?.includes("ITC AVAILABILITY REPORT") && {
            label: 'ITC Availability Report',
            icon: <BarChartIcon />,
            path: '/itcAvailReportBooks',
            component: ItcAvailReport
        },
        statutoryComplianceAccess?.includes("SECTION WISE COMPARISON") && {
            label: 'Section Wise Comparison',
            icon: <BarChartIcon />,
            path: '/sectionReport',
            component: SectionReport
        },
        statutoryComplianceAccess?.includes("ITC REVERSAL REPORT") && {
            label: 'ITC Reversal Report',
            icon: <PieChartIcon />,
            path: '/itcRevarsalReport',
            component: ItcReversalReport
        },
        statutoryComplianceAccess?.includes("VENDOR CANCELLATION REPORT") && {
            label: 'Vendor Cancellation Report',
            icon: <BubbleChartIcon />,
            path: '/VendorCancellation',
            component: VendorCancellation
        },
        statutoryComplianceAccess?.includes("MULTIMONTH REPORT") && {
            label: 'Multi-Month Report',
            icon: <InsertChartIcon />,
            path: '/MultiMonth',
            component: MultiMonth
        },
        statutoryComplianceAccess?.includes("HSN SUMMARY REPORT") && {
            label: 'HSN Summary Report',
            icon: <BarChartIcon />,
            path: '/HsnSummaryReport',
            component: HsnSummaryReport
        },
        statutoryComplianceAccess?.includes("GST INWARD COMPARISON") && {
            label: 'Inward comparison',
            icon: <PieChartIcon />,
            path: '/Inward_comparison',
            component: Gtsr9InwardComparison
        },
        statutoryComplianceAccess?.includes("GST OUTWARD COMPARISON") && {
            label: 'Outward comparison',
            icon: <BubbleChartIcon />,
            path: '/Outward_comparison',
            component: Gtsr9OutwardComparison
        },
        statutoryComplianceAccess?.includes("GST COMPUTATION REPORT") && {
            label: 'GST Computation Report',
            icon: <InsertChartIcon />,
            path: '/gst_computation_report',
            component: GSTComputationReport
        },
        statutoryComplianceAccess?.includes("RCM REPORT") && {
            label: 'RCM Report',
            icon: <BarChartIcon />,
            path: '/RcmSummary',
            component: RCMReport
        },
        statutoryComplianceAccess?.includes("GST LEDGERS") && {
            label: 'GST Ledgers',
            icon: <PieChartIcon />,
            path: '/GstLedgers',
            component: GstLedgers
        },
        statutoryComplianceAccess?.includes("FORM 16/16A") && {
            label: 'FORM 16/16A',
            icon: <BarChartIcon />,
            path: '/Form16',
            component: LogTables
        },
        statutoryComplianceAccess?.includes("TDS APPLICABILITY REPORT") && {
            label: 'TDS Applicability Report',
            icon: <BarChartIcon />,
            path: '/tdsApplicabilityReport',
            component: TdsReport
        },
         statutoryComplianceAccess?.includes("ITC/RCM ELIGIBLITY REPORT") && {
            label: 'ITC/RCM ELIGIBLITY REPORT',
            icon: <BarChartIcon />,
            path: '/rcmReport',
            component: RcmReport
        },

    ].filter(Boolean);

    const activeTab = [...workingCapitalReportOptions, ...statutoryComplianceReportOptions].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    const handleCardClick = (report) => {
        history.push(report.path);
    };

    return (
        <Box sx={{
            fontFamily: "'Inter', sans-serif",
            width: '100%',
            minHeight: '100vh',
            background: 'linear-gradient(to bottom, #e8eef5 0%, #f5f7fa 100%)',
            p: 0
        }}>
            {ActiveComponent ? (
                <Box sx={{ mt: 0 }}>
                    <ActiveComponent />
                </Box>
            ) : (
                <>
                    {/* Page Heading */}
                    <Box sx={{
                        textAlign: 'center',
                        pt: 3,
                        pb: 0.5
                    }}>
                        <Box sx={{
                            fontSize: '38px',
                            fontWeight: 900,
                            color: '#03406d',
                            letterSpacing: '2px',
                            fontFamily: '"Dosis", sans-serif',
                            textTransform: 'uppercase'
                        }}>
                            REPORTING & ANALYTICS
                        </Box>
                    </Box>
                    
                    {/* Main Container with both modules */}
                    <Box sx={{
                        display: 'flex',
                        gap: 3,
                        p: 4,
                        width: '100%'
                    }}>
                        {/* Statutory Compliance Module */}
                        {statutoryComplianceReportOptions.length > 0 && (
                            <Box sx={{
                                flex: 1,
                                background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                                borderRadius: '16px',
                                overflow: 'hidden',
                                border: '3px solid #03406d',
                                boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                            }}>
                                <Box sx={{ background: '#03406d', p: 2.5, mb: 2 }}>
                                    <Box sx={{
                                        fontSize: '24px',
                                        fontWeight: 700,
                                        color: '#ffffff',
                                        textAlign: 'center',
                                        letterSpacing: '1px'
                                    }}>
                                        STATUTORY COMPLIANCE
                                    </Box>
                                </Box>
                                <Box sx={{ p: 4, pt: 0 }}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2.5 }}>
                                        {statutoryComplianceReportOptions.map((report, index) => (
                                            <Box
                                                key={index}
                                                onClick={() => handleCardClick(report)}
                                                sx={{
                                                    background: '#ffffff',
                                                    borderRadius: '12px',
                                                    p: 3,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                    minHeight: '80px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderLeft: '5px solid #03406d',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&::before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: 0,
                                                        height: '100%',
                                                        width: '5px',
                                                        background: '#03406d',
                                                        transition: 'width 0.4s ease',
                                                        zIndex: 0
                                                    },
                                                    '&:hover': {
                                                        transform: 'translateY(-4px)',
                                                        boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                        '& > div': {
                                                            color: '#ffffff'
                                                        }
                                                    },
                                                    '&:hover::before': {
                                                        width: '100%'
                                                    }
                                                }}
                                            >
                                                <Box sx={{
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    color: '#212121',
                                                    textAlign: 'center',
                                                    position: 'relative',
                                                    zIndex: 1,
                                                    transition: 'color 0.3s ease',
                                                }}>
                                                    {report.label}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {/* Working Capital Module */}
                        {workingCapitalReportOptions.length > 0 && (
                            <Box sx={{
                                flex: 1,
                                background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                                borderRadius: '16px',
                                overflow: 'hidden',
                                border: '3px solid #03406d',
                                boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                            }}>
                                <Box sx={{ background: '#03406d', p: 2.5, mb: 2 }}>
                                    <Box sx={{
                                        fontSize: '24px',
                                        fontWeight: 700,
                                        color: '#ffffff',
                                        textAlign: 'center',
                                        letterSpacing: '1px'
                                    }}>
                                        WORKING CAPITAL
                                    </Box>
                                </Box>
                                <Box sx={{ p: 4, pt: 0 }}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2.5 }}>
                                        {workingCapitalReportOptions.map((report, index) => (
                                            <Box
                                                key={index}
                                                onClick={() => handleCardClick(report)}
                                                sx={{
                                                    background: '#ffffff',
                                                    borderRadius: '12px',
                                                    p: 3,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                    minHeight: '80px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderLeft: '5px solid #03406d',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&::before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: 0,
                                                        height: '100%',
                                                        width: '5px',
                                                        background: '#03406d',
                                                        transition: 'width 0.4s ease',
                                                        zIndex: 0
                                                    },
                                                    '&:hover': {
                                                        transform: 'translateY(-4px)',
                                                        boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                        '& > div': {
                                                            color: '#ffffff'
                                                        }
                                                    },
                                                    '&:hover::before': {
                                                        width: '100%'
                                                    }
                                                }}
                                            >
                                                <Box sx={{
                                                    fontSize: '16px',
                                                    fontWeight: 600,
                                                    color: '#212121',
                                                    textAlign: 'center',
                                                    position: 'relative',
                                                    zIndex: 1,
                                                    transition: 'color 0.3s ease',
                                                }}>
                                                    {report.label}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        )}
                    </Box>

                    {/* No Access Message */}
                    {workingCapitalReportOptions.length === 0 && statutoryComplianceReportOptions.length === 0 && (
                        <Box sx={{
                            textAlign: 'center',
                            mt: 10,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                            <Box sx={{ fontSize: '18px', color: '#607d8b', fontFamily: '"Dosis", sans-serif' }}>
                                Please activate the Report Services to access.
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
}